import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { CleanSyncFormFormFields } from '../helpers';

export const useCleanSyncFormRules = () => {
  const { t } = useTranslation();
  const required = useGetRequiredRule({ t });
  return {
    [CleanSyncFormFormFields.CHANNEL]: [required],
  };
};
